import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  enterpriseApplicationsKey,
  errorMessage,
  interviewCountsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { applicantDetailsKey } from '@features/applicant';
import { jobPostingsKey } from '@features/jobPostings';

type UseSingleApplicationActionProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useSingleApplicationAction = ({
  setErrorText,
}: UseSingleApplicationActionProps) => {
  const client = useQueryClient();

  const {
    mutate: createApplicationAction,
    isLoading: isCreateApplicationActionLoading,
  } = useMutation({
    mutationFn: (variables: {
      endpoint: string;
      payload: {
        application_id: number;
        hired_action?: string;
        body?: string;
      };
    }) =>
      axiosInstance
        .post(variables.endpoint, variables.payload)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(enterpriseApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries(applicantDetailsKey);
        client.invalidateQueries(interviewCountsKey);
        client.invalidateQueries(applicationHistoryKey);
        client.invalidateQueries(jobPostingsKey);
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });
  return {
    createApplicationAction,
    isCreateApplicationActionLoading,
  };
};
